import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import ProjectCommunicationForm from "modules/project/communications/web/form.jsx";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import { createProjectCommunication, searchProjectCommunications } from "../actions";
import { PacmanLoader } from "react-spinners";

import { Card, CardBody, Alert } from "reactstrap";
import _ from "lodash";
import { Base64toFileObject } from "modules/5_view_helpers/FileFunctions";
import { findOrCreateAddressBookCompanyContactByEmail } from "modules/address_book/company/contacts/actions";

function mapStateToProps(state) {
  return {};
}

const NewProjectCommunicationOutgoing = (props) => {
  const { history } = props;
  const returnURL = "/outlook";
  const createRole = HasRole({ resource_type: "Project::Communication", name: ["create", "moderator"] }, false, true);

  const [loading, setLoading] = useState(false);
  const [loadingString, setLoadingString] = useState(false);
  const [alerts, setAlerts] = useState([]);

  const [initialValues, setInitialValues] = useState({ direction: "outgoing", attachments_attributes: [] });
  // Expose the initialValues and setInitialValues to the window object so it can be used in the Outlook addin.

  useEffect(() => {
    if (window.__LION_OUTLOOK_PAYLOAD__) {
      const outlookPayload = window.__LION_OUTLOOK_PAYLOAD__;

      const attachmentsArray = _.map(outlookPayload.attachments_attributes, (attachment) => {
        const file = Base64toFileObject(attachment.attachment, attachment.name, attachment.type);

        return {
          attachment: file,
          name: attachment.name,
          type: file.type,
          size: file.size,
          url: URL.createObjectURL(file),
        };
      });

      const newInitialValues = {
        direction: "outgoing",
        subject: outlookPayload.subject,
        from: outlookPayload.from,
        body: outlookPayload.body,
        mailgun_message_id: outlookPayload.message_id,
        attachments_attributes: attachmentsArray,
      };
      setInitialValues(newInitialValues);

      const to_emails = outlookPayload?.to_emails;
      const cc_emails = outlookPayload?.cc_emails;

      _.each(to_emails, (to) => {
        const email = to.email;
        const name = to.name;

        props.findOrCreateAddressBookCompanyContactByEmail(email, name).then((response) => {
          const contact = response.value?.data;

          setInitialValues((prevState) => {
            let prevTosAttributes = prevState?.tos_attributes || [];

            return {
              ...prevState,
              tos_attributes: [...prevTosAttributes, { value: contact.id, label: contact.display_name, contact_id: contact.id }],
            };
          });
        });
      });

      
      _.each(cc_emails, (cc) => {
        const email = cc.email;
        const name = cc.name;

        props.findOrCreateAddressBookCompanyContactByEmail(email, name).then((response) => {
          const contact = response.value?.data;

          setInitialValues((prevState) => {
            let prevCcsAttributes = prevState?.ccs_attributes || [];

            return {
              ...prevState,
              ccs_attributes: [...prevCcsAttributes, { value: contact.id, label: contact.display_name, contact_id: contact.id }],
            };
          });
        });
      });
    }
  }, []);

  const submitForm = (values) => {
    setLoadingString("Creating communication...");
    const createRequest = props.createProjectCommunication(values?.project_id_selected, values);
    createRequest.then(successfullySubmitted);
    createRequest.catch((error) => {
      setAlerts((prevState) => {
        let updatedAlerts = [...prevState];
        updatedAlerts.push(`That didn't work. Please try again.`);
        return updatedAlerts;
      });
      setLoadingString(false);
    });
  };

  const successfullySubmitted = () => {
    if (window.chrome?.webview) {
      window.chrome.webview.postMessage("close");
    }
    setLoadingString("Saved Closing Window...");
  };

  if (loading) {
    return <PacmanLoader />;
  }

  if (loadingString) {
    return <div>{loadingString}</div>;
  }

  if (!createRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardBody>
          {alerts.map((alert) => {
            return <Alert color="success">{alert}</Alert>;
          })}
          <Form
            component={ProjectCommunicationForm}
            outlookMode
            onSubmit={submitForm}
            formLabel="Create"
            initialValues={initialValues}
            cancelFunction={() => {
              if (window.chrome?.webview) {
                window.chrome.webview.postMessage("close");
              }
            }}
            mutators={{
              ...arrayMutators,
            }}
            {...props}
          />
        </CardBody>
      </Card>
    );
  }
};

export default connect(mapStateToProps, { createProjectCommunication, searchProjectCommunications, findOrCreateAddressBookCompanyContactByEmail })(
  NewProjectCommunicationOutgoing
);
